import api from "./Api";

class FornecedorEmailService {
  GetFornecedorEmail(payload) {
    return api.get("/v1/fornecedorEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  PostFornecedorEmail(payload) {
    return api.post("/v1/fornecedorEmail/", payload).then((response) => {
      return response.data;
    });
  }

  PutFornecedorEmail(payload) {
    return api.put("/v1/fornecedorEmail/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteFornecedorEmail(payload) {
    return api.delete("/v1/fornecedorEmail/" + payload).then((response) => {
      return response.data;
    });
  }

  GetFornecedorEmailOData(payload) {
    return api.get("/OData/FornecedorEmail" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new FornecedorEmailService();
